/**
 * AMD Module + commonjs dependency management
 *
 */

define(function(require) {
	/**
	 * static inclues
	 *
	 */
    var $ = require('jquery');
    
    require("../lib/slick.min.js");



    /**
	 * private functions
	 *
	 */
    var thisObject = this;






	/**
	 * public functions
	 *
	 */
    var self = {};

    self.slick = function(selector){
        selector.slick({
            slide       : '.layout_latest',
            infinite    : true,
            fade        : true,
            arrows      : true,
            dots        : true,
            appendArrows: '.containerSlickNav',
            appendDots  : '.containerSlickDots',
            prevArrow   : '<div class="slick-prev slick-arrow" aria-label="Previous">'+
            '<svg xmlns="http://www.w3.org/2000/svg" width="90.78" height="163.41" viewBox="0 0 90.78 163.41"><path class="cls-1" d="M87.22,3.51,7.2,84.67a.59.59,0,0,1,.11.1l79.75,75"/></svg>'+
            '</div>',
            nextArrow   : '<div class="slick-next slick-arrow" aria-label="Next">'+
            '<svg xmlns="http://www.w3.org/2000/svg" width="90.73" height="163.41" viewBox="0 0 90.73 163.41"><path class="cls-1" d="M3.72,3.64l79.75,75,.11.1-80,81.16"/></svg>'+
            '</div>',
            
            // draggable   : false,
            autoplay    : true,
            autoplaySpeed: 4000,
            pauseOnFocus : false,
            pauseOnHover : false,

            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        fade        : false,
                        centerMode  : true,
                        centerPadding: '22px'
                    }          
                }
            ]
          });
    };


    /**
	 * do stuff
	 *
	 */
    self.slick( $('.slick-slider') );
    return self;
});



//////////////////
// WEBPACK FOOTER
// ./chunk/slider__slick.js
// module id = 8
// module chunks = 0